var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top"},[_c('h1',[_vm._v("AnyTeach 约课平台")]),_c('h2',[_vm._v("最具革命性的幼少儿英语启蒙")])])}]

export { render, staticRenderFns }